import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v0/body_mails'

class BodyMailEndpoint extends BaseEndpoint {
    list(params = null) {
        if (typeof params == 'string') {
            return this.client.$get(apiPath + params)
        } else {
            return this.client.$get(apiPath, {params: params})
        }
    }

    detail(code, params = null) {
        return this.client.$get(apiPath + '/' + code, {params: params}).catch(err => {
            console.log('Unsuccessful response: ', err);
        })
    }

    update(id, fields) {
        if (typeof fields.append !== 'undefined') {
            fields.append('_method', 'PUT')
        } else {
            fields._method = 'PUT'
        }
        return this.client.$post(`${apiPath}/${id}`, fields);
    }

    /*add(fields) {
        return this.client.$post(`${apiPath}`, fields);
    }*/
}

export default BodyMailEndpoint;
